import { forwardRef } from 'react';

import { Transition, TransitionProps } from './Transition.js';

export type TransitionFadeProps<T extends React.ElementType> = Omit<
  TransitionProps<T>,
  'enter' | 'exit'
>;

const enter = { opacity: 1 };
const exit = { opacity: 0 };

/**
 * Fade box transition
 *
 * @see https://material-ui.com/api/fade/
 */
export const TransitionFade = forwardRef(
  <T extends React.ElementType>(
    props: TransitionFadeProps<T>,
    ref: React.ForwardedRef<React.ElementRef<T>>
  ) => {
    return <Transition ref={ref} enter={enter} exit={exit} {...props} />;
  }
);
